enum TabButtonEvents {
  /**
   * Emits when a `TabButton` is pressed.
   * 
   * Function callback signature:
   * 
   * event: `createjs.MouseEvent`. The event data about the press
   * 
   * tabButton: `TabButton`. The button that emitted the event.
   */
  PRESSED = 'pressed',
}

export default TabButtonEvents;
